module.exports = __webpack_public_path__ + "static/media/paul.95d5a141.jpg";